import {
  USER_PRIVILEGE_SUCCESS,
  USER_PRIVILEGE_FAILED,
  SIDE_MENU_ON_LOAD_SUCCESS,
  REQUEST_MESSAGE_SUCCESS,
  REQUEST_MESSAGE_LOAD,
} from './actions';

import {
  APP_LOGOUT
} from 'redux-root/actions';

const initialState = {
  init: false,
  loadingMessageNum: true,
  messageNum: 0,
  userPrivilege: {}
}

export function sideMenuReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case USER_PRIVILEGE_SUCCESS:
      return {
        ...state,
        init: true,
        userPrivilege: data
      }
    case USER_PRIVILEGE_FAILED:
      return {
        ...state,
        init: true,
        userPrivilege: {}
      }
    case SIDE_MENU_ON_LOAD_SUCCESS:
      return {
        ...state,
        init: true
      }
    case APP_LOGOUT:
      return {
        ...state,
        init: false,
        userPrivilege: {}
      }
    case REQUEST_MESSAGE_SUCCESS:
      return {
        ...state,
        loadingMessageNum: false,
        messageNum: data.pendingNumber
      }
      case REQUEST_MESSAGE_LOAD:
        return {
          ...state,
          messageNum: 0
        }
    default:
      return state;
  }
}
  